export const PAGE_BACK = 'PAGE_BACK';
export const PAGE_NEXT = 'PAGE_NEXT';
export const SET_PAGE = 'SET_PAGE';
export const SET_ORDER_BY = 'SET_ORDER_BY';
export const SET_FILTERS_ACTIVE = 'SET_FILTERS_ACTIVE';
export const PAGE_MORE_BACK = 'PAGE_MORE_BACK';
export const PAGE_MORE_NEXT = 'PAGE_MORE_NEXT';
